import {useFormContext} from '@yandex-delivery/form'
import {useRefresh} from '@yandex-delivery/hooks'
import clsx from 'clsx'
import React, {memo, useMemo, useState} from 'react'

import {i18n} from 'src/shared/config'
import type {Order} from 'src/shared/types'

import {Banner} from './Banner/Banner'
import * as classes from './Banners.classes'
import type {Banner as BannerType} from './consts'
import {BannerAction, BannerImageType} from './consts'

type Props = {
  mobile?: boolean
}

export const Banners = memo<Props>(function Banners({mobile}) {
  const [activeBannerIndex, setActiveBannerIndex] = useState<number>(0)
  const isBusiness = useFormContext<Order>().watch('isBusiness')
  const {banners, refreshHandler} = useMemo(() => {
    const bannersToShow = isBusiness ? businessBanners : privateBanners

    return {
      banners: bannersToShow,
      refreshHandler() {
        setActiveBannerIndex(prevState => (prevState + 1) % bannersToShow.length)
      },
    } as const
  }, [isBusiness])

  useRefresh(refreshHandler, {interval: 5000})

  return (
    <div className={mobile ? classes.rootMobile : classes.root}>
      {banners.map((banner, index) => {
        return (
          <Banner
            key={index}
            banner={banner}
            className={clsx(classes.item, index === activeBannerIndex && classes.active)}
          />
        )
      })}
    </div>
  )
})

const privateBanners: BannerType[] = [
  {
    action: BannerAction.DownloadApp,
    imageType: BannerImageType.OrderDeliveriesInYandexGo,
    title: i18n('order.banner.order-in-yandex-go.title', 'Заказывайте доставки \u2794\u000Aв приложении Яндекс Go'),
  },
  {
    action: BannerAction.CopyPhoneNumber,
    imageType: BannerImageType.Sofa,
    title: i18n('order.banner.order-cargo-delivery.value', {fallBackToKey: false}),
    description: i18n('order.banner.order-delivery-by-phone.description', 'Заказать грузовую доставку по телефону'),
    value: i18n('order.banner.order-cargo-delivery.value', {fallBackToKey: false}),
  },
  {
    action: BannerAction.CopyPhoneNumber,
    imageType: BannerImageType.Truck,
    title: i18n('order.banner.order-cargo-delivery.value', {fallBackToKey: false}),
    description: i18n('order.banner.order-delivery-by-phone.description', 'Заказать грузовую доставку по телефону'),
    value: i18n('order.banner.order-cargo-delivery.value', {fallBackToKey: false}),
  },
  {
    action: BannerAction.DownloadApp,
    imageType: BannerImageType.Courier,
    title: i18n('order.banner.detect-orders-in-app', 'Отслеживайте заказы \u2794\u000Aв приложении Яндекс Go'),
  },
]
const businessBanners = [
  {
    action: BannerAction.ReadMore,
    description: i18n(
      'order.banner.payment-from-current-account.description',
      'Получайте документы на каждое пополнение баланса',
    ),
    imageType: BannerImageType.PaymentFromCurrentAccount,
    title: i18n('order.banner.payment-from-current-account.title', 'Оплата с расчётного счёта'),
    // TODO - эта ссылка - фейк, нужно будет заменить на реальную
    value: 'https://dostavka.yandex.ru',
  },
  {
    action: BannerAction.ReadMore,
    description: i18n(
      'order.banner.team-access.description',
      'Доступ к заказам и оплате через кабинет или Яндекс Go для сотрудников',
    ),
    imageType: BannerImageType.TeamAccess,
    title: i18n('order.banner.team-access.title', 'Доступы команде'),
    // TODO - эта ссылка - фейк, нужно будет заменить на реальную
    value: 'https://dostavka.yandex.ru',
  },
  {
    action: BannerAction.ReadMore,
    description: i18n(
      'order.banner.web-cabinet-and-yandex-go.description',
      'Удобный доступ и с компьютера и с телефона',
    ),
    imageType: BannerImageType.WebCabinetAndYandexGo,
    title: i18n('order.banner.web-cabinet-and-yandex-go.title', 'Веб-кабинет и Яндекс Go'),
    // TODO - эта ссылка - фейк, нужно будет заменить на реальную
    value: 'https://dostavka.yandex.ru',
  },
]
